import React, { useEffect, useState } from "react";
import SpecialOfferHeader from "../component/Offers/SpecialOfferHeader.jsx";
import FoodItem from "../component/Offers/FoodItem.jsx";
import Header from "../component/layout/Header.jsx";
import Footer from "../component/layout/Footer.jsx";
import supperMizza from "../assets/superpizza.png";
import suppebonus from "../assets/superebonus.png";
import offerSideImage from "../assets/offersideimage.png";
import offer1 from "../assets/offerpage1.png";
import offer2 from "../assets/offer2.png";
import offer3 from "../assets/offer3.png";
import offer4 from "../assets/offer4.png";
import sectionImage from "../assets/Section.png";
import AboveHeaderImage from "../assets/aboveheaderimage.png";
import { useNavigate, useParams } from "react-router-dom";
import api from "../utils/api.js";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie"
import { addToCart } from "../redux/action/cart.js";
import { FaArrowLeft, FaArrowRight, FaSpinner } from "react-icons/fa";
import styles from "../component/styles.js";
import { showCustomAlert } from "../component/User/Signup/Toast.jsx";
function OfferDetailPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  const dispatch = useDispatch();
  const { offerId1 } = useParams(); // Get the offerId from the URL
  const isOfferPage = Boolean(offerId1); // Check if the user is on a specific offer page
  const [loading, setLoading] = useState(true); // Loading state
  const { cart } = useSelector((state) => state.cart);
const [loading1,setLoading1]=useState(null)

  const { offerId } = useParams();
  // const navigation = useNavigate();

  const [offer, setOffer] = useState(null);
  const [products, setProducts] = useState([]);
// console.log('=======products', products)
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(2);
 

  useEffect(() => {
    const updateItemsPerSlide = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setItemsPerSlide(4); // Large screens
      } else if (width >= 768) {
        setItemsPerSlide(3); // Medium screens
      } else {
        setItemsPerSlide(2); // Small screens
      }
    };

    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);

    const interval = setInterval(() => {
      setCurrentIndex(
        (prevIndex) =>
          (prevIndex + 1) % Math.ceil(products.length / itemsPerSlide)
      );
    }, 5000);

    return () => {
      window.removeEventListener("resize", updateItemsPerSlide);
      clearInterval(interval);
    };
  }, [products.length, itemsPerSlide]);
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await api.get(`/offer/${offerId}`); // Get all offers
        console.log("🚀 ~ fetchOffers ~ response:", response);
        if (response.status === 200) {
          setOffer(response.data.results); // Store offers data in state
        } else {
          console.error("Failed to fetch offers:", response);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchOffers();
  }, []);
  // const handleOfferClick = (offerId) => {
  //   navigation(`/offers/${offerId}`); // Navigate to the offer page with the offerId as part of the URL
  // };
  const handlePageChange = (direction) => {
    setCurrentIndex((prevIndex) => {
      const totalPages = Math.ceil(products.length / itemsPerSlide);
      if (direction === "next") {
        return prevIndex < totalPages - 1 ? prevIndex + 1 : prevIndex;
      } else if (direction === "prev") {
        return prevIndex > 0 ? prevIndex - 1 : prevIndex;
      }
      return prevIndex;
    });
  };

  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
   const statusRes =  Cookies.get(`restaurantStatus_${RestaurantSavedId}`)
   const addToCartHandler = (product, discountValue) => {
    if (statusRes === 'closed') {
      showCustomAlert({
        title: 'Restaurant is closed!',
        html: '<p style="color: #555;">Restaurant is not accepting orders right now</p>',
        icon: 'suCcess',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 4000,
      });
    } else {
      console.log("🚀 ~ addToCartHandler ~ discountValue:", discountValue);
  
      const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
      const isItemExists = existingCart.find((item) => item.productId === product._id);
  
      console.log("isItemExists", isItemExists);
  
      const discountAmount = (product.price * discountValue) / 100;
      console.log("🚀 ~ addToCartHandler ~ discountAmount:", discountAmount);
  
      const finalPrice = (product.price - (discountAmount || 0)).toFixed(2);
      console.log("🚀 ~ Final Price:", finalPrice);
  
      if (isItemExists) {
        // Update the quantity of the existing product
        const updatedProduct = {
          ...isItemExists,
          quantity: isItemExists.quantity + 1,
        };
  
        dispatch(addToCart(updatedProduct));
  
        // Update localStorage
        const updatedCart = existingCart.map((item) =>
          item.productId === product._id ? updatedProduct : item
        );
        localStorage.setItem('cart', JSON.stringify(updatedCart));
  
        showCustomAlert({
          title: 'Item Added!',
          html: '<p style="color: #555;">Add More Items to get reward.</p>',
          icon: 'success',
          confirmButtonText: 'View Menu',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 4000,
        });
      } else {
        if (product.stock < 1) {
          toast.error("Product stock limited!");
        } else {
          // Add new product to the cart
          const cartData = {
            ...product,
            productId: product._id,
            quantity: 1,
            basePrice: finalPrice,
            actualPrice: product.price,
            offerId,
            image: product.images[0],
          };
  
          dispatch(addToCart(cartData));
  
          // Save to localStorage
          const updatedCart = [...existingCart, cartData];
          localStorage.setItem('cart', JSON.stringify(updatedCart));
  
          showCustomAlert({
            title: 'Item Added!',
            html: '<p style="color: #555;">Add More Items to get reward.</p>',
            icon: 'success',
            confirmButtonText: 'View Menu',
            confirmButtonColor: '#af313d',
            background: '#ffffff',
            timer: 4000,
          });
        }
      }
    }
  };
  
  
  useEffect(() => {
    const fetchOffersOrProducts = async () => {
      try {
        setLoading1(true); // Set loading to true before fetching

        if (offerId) {
          console.log("🚀 ~ fetchOffersOrProducts ~ offerId:", offerId);

          // Fetch specific offer details if offerId is present
          const response = await api.get(`/offer/${offerId}`);
          if (response.status === 200) {
            console.log("🚀 ~ fetchOffersOrProducts ~ response:", response);
            setOffer(response.data.data);

            // Fetch products related to this specific offer
            const productPromises = response.data.data.applicableProducts.map(
              async (product) => {
                const productResponse = await api.get(
                  `/menu-food/${product.menuFoodId}`
                );
                return productResponse.data.data;
              }
            );

            const fetchedProducts = await Promise.all(productPromises);
            console.log('==========', fetchedProducts)
            setProducts(fetchedProducts);
          } else {
            console.error("Failed to fetch offer details:", response);
          }
        } else {
          console.log("triger");

          // Fetch all offers and their applicable products
          const response = await api.get("/offer");
          if (response.status === 200) {
            const allOffers = response.data.results;
            console.log("🚀 ~ fetchOffersOrProducts ~ allOffers:", allOffers);

            setOffer(allOffers);

            // Combine applicable products from all offers
            const productPromises = allOffers.flatMap((offer) =>
              offer.applicableProducts.map(async (product) => {
                const productResponse = await api.get(
                  `/menu-food/${product?.menuFoodId}`
                );
                return productResponse.data.data;
              })
            );

            const fetchedProducts = await Promise.all(productPromises);
            setProducts(fetchedProducts);
          } else {
            console.error("Failed to fetch offers:", response);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading1(false); // Set loading to false after fetching
      }
    };

    fetchOffersOrProducts();
  }, [offerId]);
  if (loading || loading1) {
    // Show loader while fetching data
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
      </div>
    );
  }
  const visibleProducts = products.slice(
    currentIndex * itemsPerSlide,
    (currentIndex + 1) * itemsPerSlide
  );

  return (
    <main className="flex flex-col">
      <Header activeLink={"offers"} />
      <div className="relative overflow-visible">
        <img src={sectionImage} className="h-full w-full object-cover" />
        <img
          src={AboveHeaderImage}
          className="absolute top-[-14%] left-[13%] w-[70%] h-auto object-cover z-10"
        />
      </div>

      {/* Offer Details Section */}
      {offer && (
        <div className="md:mt-[16rem] mt-[80px]">
          <div
            className={`${styles.productTitle} flex items-center font-baloo justify-center mb-12`}
          >
            Offer Detail
          </div>
          <div className="w-full md:flex gap-[4rem]  block  justify-center px-4">
            <div className="w-full md:w-[50%] px-4 justify-center items-center flex ">
              <img
                src={offer.image}
                className="md:w-[70%] md:px-0  w-full object-cover"
                alt="Offer"
              />
            </div>
            <div className="w-full md:w-[50%] px-4 md:px-0 pt-5">
              <h1 className={`${styles.productTitle} text-2xl body font-bold mb-4`}>
                {offer.title}
              </h1>
              <p className="text-gray-600 mb-6 font-baloo ">{offer.description}</p>
              <div className="pt-3">
                <div className="flex items-center gap-8 mb-4">
                  <h4
                    className={`${styles.productDiscountPrice} text-xl font-semibold body`}
                  >
                    Discount:
                  </h4>
                  <span className="text-lg bg-yellow-100 text-[#C97C2A] px-3 py-1 rounded-full shadow font-baloo ">
                    {offer.discountValue}%
                  </span>
                </div>
                <div className="flex items-center gap-8">
                  <h4 className="text-[#C97C2A] text-xl font-semibold body">
                    End Date:
                  </h4>
                  <span className="text-lg text-gray-500 font-medium font-baloo ">
                    {new Date(offer.endDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Products Carousel */}
      <div className=" flex items-center justify-center text-center">
        <h1 className={`${styles.productTitle} text-2xl font-bold body mb-4 mt-8`}>
          Applicable Products
        </h1>
      </div>

      <div className="max-w-full overflow-hidden mt-12">
        {/* Carousel */}
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5 mb-4 px-4">
          {visibleProducts.map((product, index) => (
            <div key={index} className="flex items-center justify-center">
              <FoodItem
                imageSrc={product.images[0]}
                
                name={product.name}
                price={product.price}
                description={product.description}
                discount={offer?.discountValue}
                onOrder={() =>
                  addToCartHandler(product, offer?.discountValue)
                } // Pass discountValue
              />
            </div>
          ))}
        </div>
      </div>

      {products.length > 0 && (
        <div className="flex justify-between items-center px-4">
          <button
            onClick={() => handlePageChange("prev")}
            disabled={currentIndex === 0}
            className="p-2 hover:bg-gray-300 rounded-r-lg"
          >
            <FaArrowLeft />
          </button>

          {/* <span className="px-4">
            Page {currentIndex + 1} of {Math.ceil(products.length / itemsPerSlide)}
          </span> */}

          <button
            onClick={() => handlePageChange("next")}
            disabled={
              currentIndex === Math.ceil(products.length / itemsPerSlide) - 1
            }
            className="p-2 hover:bg-gray-300 rounded-r-lg"
          >
            <FaArrowRight />
          </button>
        </div>
      )}

      <Footer />
    </main>
  );
}

export default OfferDetailPage;
